import { render, staticRenderFns } from "./IconGift.vue?vue&type=template&id=06dc6689&"
import script from "./IconGift.vue?vue&type=script&lang=ts&"
export * from "./IconGift.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports